// videoThumb.js — single source of truth for grabbing a video frame as a data-URL
export const getVideoFrameThumb = (url, atSec = 1.0, targetH = 160) => new Promise((resolve) => {
    if (!url) return resolve(null);
    try {
      const key = `vidthumb::${url}`;
      const cached = sessionStorage.getItem(key);
      if (cached) return resolve(cached);
  
      const v = document.createElement('video');
      v.crossOrigin = 'anonymous';
      v.preload = 'metadata';
      v.muted = true;
  
      const cleanup = () => { try { v.remove(); } catch {} };
  
      v.onloadedmetadata = () => {
        const t = Math.min(atSec, (v.duration || atSec) - 0.05);
        v.currentTime = Math.max(0.05, isFinite(t) ? t : atSec);
      };
  
      v.onseeked = () => {
        try {
          const c = document.createElement('canvas');
          const scale = targetH / v.videoHeight;
          c.width  = Math.max(1, Math.round(v.videoWidth * scale));
          c.height = Math.max(1, Math.round(v.videoHeight * scale));
          c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
          const dataUrl = c.toDataURL('image/jpeg', 0.7);
          try { sessionStorage.setItem(key, dataUrl); } catch {}
          resolve(dataUrl);
        } catch { resolve(null); } finally { cleanup(); }
      };
  
      v.onerror = () => { cleanup(); resolve(null); };
      v.src = url.includes('#t=') ? url : `${url}#t=${atSec}`;
      v.style.position = 'fixed'; v.style.left = '-9999px'; v.style.width = '1px'; v.style.height = '1px';
      document.body.appendChild(v);
    } catch { resolve(null); }
  });
  